<template>
  <div class="fileinput text-center">
    <div
      class="fileinput-new thumbnail"
      :class="{ 'img-circle': type === 'avatar' }"
    >
     <template v-if="isPDF">
        <!-- Exibe apenas o nome do arquivo PDF -->
        <p>{{ fileName }}</p>
      </template>
      <template v-else>
        <!-- Exibe imagem com <img> -->
        <img :src="image" alt="preview" />
      </template>
    </div>
    <div>
      <span class="btn btn-primary btn-simple btn-file">
        <span class="fileinput-new">{{
          fileExists ? changeText : selectText
        }}</span>
        <input type="hidden" value="" name="" />
        <input
          accept="image/*,application/pdf"
          @change="handlePreview"
          type="file"
          name="..."
          class="valid"
          :multiple="false"
          aria-invalid="false"
        />
      </span>
      <base-button v-if="fileExists" @click="removeFile" round type="danger">
        <i class="fas fa-times"></i> {{ removeText }}
      </base-button>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";

export default {
  name: "image-upload",
  props: {
    type: {
      type: String,
      default: "",
      description: 'Image upload type (""|avatar)',
    },
    src: {
      type: String,
      default: "",
      description: "Initial image to display",
    },
    selectText: {
      type: String,
      default: "Select image",
    },
    changeText: {
      type: String,
      default: "Change",
    },
    removeText: {
      type: String,
      default: "Remove",
    },
    formatosValidos: {
      type: Array,
      default: () => [],
    },
    msgError: {
      type: String,
      default: "",
    }
  },
  data() {
    let avatarPlaceholder =
      "https://demos.creative-tim.com/vue-white-dashboard-pro/img/placeholder.jpg";
    let imgPlaceholder =
      "https://demos.creative-tim.com/vue-white-dashboard-pro/img/image_placeholder.jpg";
    return {
      placeholder: this.type === "avatar" ? avatarPlaceholder : imgPlaceholder,
      imagePreview: null, isPDF: false, fileName: "",
    };
  },
  computed: {
    fileExists() {
      return this.imagePreview !== null;
    },
    image() {
      return this.imagePreview || this.src || this.placeholder;
    },
  },
  methods: {
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    handlePreview(event) {
      let file = event.target.files[0];
      if(!file) return;

     

      if (!this.formatosValidos.includes(file.type)) {
        this.showSwal('auto-close', 'Formato inválido', this.msgError, 'error');
        return;
      }

        this.isPDF = file.type === "application/pdf";

        if (this.isPDF) {
          //tratamento PDF
          const maxSizeMBpdf = 1;
          const maxSizeBytespdf = maxSizeMBpdf * 1024 * 1024;
          if (file.size > maxSizeBytespdf) {
            const msg = `O arquivo ${file.name} excede o tamanho permitido. O máximo é ${maxSizeMBpdf}MB. 
                    Tamanho atual: ${maxSizeBytespdf} bytes.`;
          this.showSwal('auto-close', 'Tamanho do arquivo inválido',msg, 'error');
          
          this.imagePreview = null;
          this.fileName = "";
          return;
          }

          this.imagePreview = URL.createObjectURL(file);
          this.fileName = file.name;
        } else {
          //tratamento imagem
          const maxSizeMBimg = 2;  // Define o limite de tamanho para 2 MB
          const maxSizeBytesimg = maxSizeMBimg * 1024 * 1024;
          if (file.size > maxSizeBytesimg) {
          const msg = `A imagem excede o tamanho permitido. O máximo é ${maxSizeMBimg}MB. 
                    Tamanho atual: ${maxSizeBytesimg} bytes.`;
          this.showSwal('auto-close', 'Tamanho da imagem inválido', msg, 'error');
          //this.showSwal('auto-close', 'Arquivo muito grande', `O arquivo ${file.name} excede o tamanho máximo permitido de ${maxSizeMBimg}MB.`, 'error');
          this.fileName = "";
          this.imagePreview = null;
          return;
        }
          this.imagePreview = URL.createObjectURL(file);
          this.fileName = "";
        }

        this.$emit("change", file);
              
      
    },
    removeFile() {
      this.imagePreview = null;
      this.fileName = "";
      this.$emit("change", null);
    },
  },
};
</script>
<style></style>
